import PageHeader from "../../components/PageHeader"
import { useCallback, useEffect, useState } from "react"
import { LMSBASEURL } from "../../config/apiUrls"
import { Link } from "react-router-dom"
import { Calendar, Clock, Users, MapPin } from "lucide-react"


export default function BatchListPage() {
  const [studentAllBatchList, setStudentAllBatchList] = useState([])
  const [activeBatchId, setActiveBatchId] = useState(null) 
  const [loadbatch,setLoadBatch] = useState(false)

  const token = process.env.REACT_APP_API_TOKEN
  const studentId = sessionStorage.getItem("id")
  const programCategoryId = sessionStorage.getItem("program_category_id")

  const fetchBatchList = useCallback(async () => {
    const raw = JSON.stringify({
      user_id: studentId,
    })

    try {
      setLoadBatch(true)
      const response = await fetch(`${LMSBASEURL}/api/get-student-batch`, {
        method: "POST",
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: raw,
      })

      const result = await response.json()
      if (!response.ok) throw new Error(result.message || "Failed to load batches")
      setStudentAllBatchList(Array.isArray(result) ? result : [])
    } catch (error) {
      console.error("Batch Fetch Error:", error.message)
      setStudentAllBatchList([])
    } finally{
      setLoadBatch(false)
    }
  }, [studentId, token])

  useEffect(() => {
    fetchBatchList()
  }, [fetchBatchList])

  return (
    <>
      <PageHeader
        title="My Batches"
        breadcrumbs={[
          { label: "Dashboard", path: "/dashboard" },
          { label: "All Batches", active: true },
        ]}
      />

      {/* filter section for future implement */}
      {/* <div className="card mb-4 shadow-sm">
        <div className="card-body">
          <div className="row g-3">
            <div className="col-md-3">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search batch..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search course..."
                  value={courseFilter}
                  onChange={(e) => setCourseFilter(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-3">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by Instructor..."
                  value={instructorFilter}
                  onChange={(e) => setInstructorFilter(e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-3 d-flex gap-2">
              <button className="btn btn-primary btn-sm w-100 d-flex align-items-center justify-content-center">
                <Filter size={14} className="me-1" />
                Filter
              </button>
              <button
                className="btn btn-outline-secondary btn-sm w-100 d-flex align-items-center justify-content-center"
                onClick={handleReset}
              >
                <RotateCcw size={14} className="me-1" />
                Reset
              </button>
            </div>
          </div>
        </div>
      </div> */}

      <>
      {loadbatch ? <div className="py-4">
        <div className="d-flex justify-content-center align-items-center" style={{ height: "400px" }}>
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>:
        <div className="row">
          <div className="col-12">
            {studentAllBatchList?.length > 0 ? (
              <>
                <div className="row">
                  {studentAllBatchList?.map((batch) => (
                    <BatchCard 
                      key={batch.id}
                      isActive={activeBatchId === batch.id}
                      onToggle={() =>
                        setActiveBatchId((prev) =>
                          prev === batch.id ? null : batch.id
                        )
                      } 
                      batch={batch} 
                    />
                  ))}
                </div>
                {studentAllBatchList.map((batch) =>
                  activeBatchId === batch.id ? (
                    <div key={batch.id + "_videos"} className="col-12 mb-4">
                      <VideoTable uploadedVideos={batch.uploaded_videos || []} title={batch?.batch_name}/>
                    </div>
                  ) : null
                )}
              </>
            ) : (
              <div className="card">
                <div className="card-body text-center py-5">
                  <div className="mb-4">
                    <i className="bi bi-inbox display-1 text-muted"></i>
                  </div>
                  <h4 className="text-muted mb-3">No batches found</h4>
                  <p className="text-muted mb-4">
                    {programCategoryId === "11"
                      ? "All Practical projects are conducted in Lab"
                      : "You are not enrolled in any batches yet."}
                  </p>
                </div>
              </div>
            )}
          </div>
        </div>}
      </>
    </>
  )
}

function BatchCard({ batch, isActive, onToggle }) {
  const getModeClass = (type) => {
    return type === "regular" ? "text-primary" : "text-success"
  }

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
    })
  }

  const formatDays = (days) => {
    return days?.split(",")
      .map((day) =>{
        return(
          <span className="ms-1 border border-success px-1 rounded text-success">{day?.trim()?.substring(0, 3)}</span>
        )
      })
  }

  return (
    <div className="col-lg-6 col-xl-4 mb-4">
      <div className="card-body padnone">
        <div style={{ position: "relative" }}>
          <div className="gallery-box card fillcolor" style={{ padding: 0 }}>
            <div className="card mb-0 yellowborder">
              <div className="d-flex position-relative">

                <div className="card-body pt-3">
                  <div className="bg-white rounded p-2 mb-1 ">
                    <div className="d-flex justify-content-between align-items-start">
                      <div className="flex-grow-1">
                        <h5 className="card-title mb-1 text-dark fw-bold">{batch.batch_name}</h5>
                        <p className="text-muted small mb-2">{batch.description}</p>
                      </div>
                      <div className="d-flex flex-column align-items-end gap-1">
                        <span className={`badge rounded-pill ${getModeClass(batch?.batch_type)} bg-opacity-10 border`}>
                          {batch?.batch_type.toUpperCase()}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="row g-2 mb-3">
                    <div className="col-12">
                      <div className="d-flex align-items-center text-muted small">
                        <Calendar size={14} className="me-2 text-primary" />
                        <span className="fw-medium">Duration:</span>
                        <span className="ms-1">
                          {formatDate(batch.start_date)} - {formatDate(batch.end_date)}
                        </span>
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="d-flex align-items-center text-muted small">
                        <Clock size={14} className="me-2 text-primary" />
                        <span className="fw-medium">Schedule:</span>
                        {formatDays(batch.days)}
                      </div>
                    </div>
                  </div>
                  <div className="d-flex gap-2">
                    <Link
                      className="btn btn-primary w-100 d-flex align-items-center justify-content-center"
                      to={`/batch/${batch.id}`}
                    >
                      {/* <MapPin size={16} className="me-2" /> */}
                      View Schedule
                    </Link>
                    {/* <Link
                     className="btn btn-primary w-100 d-flex align-items-center justify-content-center"
                      to={`/batch/${batch.id}?video=true`}
                    >
                      <MapPin size={16} className="me-2" />
                      Video
                    </Link> */}
                    {/* {batch?.uploaded_videos?.length > 0 && (
                      <button
                        className="btn btn-outline-secondary w-100"
                        onClick={onToggle}
                      >
                        {isActive ? "Hide Videos" : "View Videos"}
                      </button>
                    )} */}
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}


function VideoTable({ uploadedVideos, title }) {
  return (
    <div className="card yellowborder">
      <h6 className="fw-semibold m-1 py-3">
        Uploaded videos for ({title})
      </h6>
      <div className="table-responsive">
        <table className="table table-hover mb-0">
          <thead className="table-light">
            <tr>
              <th>Name</th>
              <th>Size</th>
              <th>Date</th>
              <th>Play</th>
              <th>Download</th>
            </tr>
          </thead>
          <tbody>
            {uploadedVideos.map((video, index) => (
              <tr key={index}>
                <td style={{ maxWidth: 280, wordBreak: "break-word" }}>{video.name}</td>
                <td>{video.size}</td>
                <td>{new Date(video.date).toLocaleString()}</td>
                <td>
                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => window.open(video.url, "_blank")}
                  >
                    <i className="bi bi-play-circle me-1"></i> Play
                  </button>
                </td>
                <td>
                  <a className="btn btn-sm btn-outline-info" href={video.url} download>
                    <i className="bi bi-download me-1"></i> Download
                  </a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}